export enum EPersona {
    Employee = 'Employee',
    Admin = 'Admin',
    FK = 'FK',
}

// Personas werden als Array von EPersona-Werten verwendet
